import React from "react";

const SoftwareEngineeringLayout = () => {
    return (
        <div className="bg-white">

            {/* ================= HERO ================= */}
            <section
                className="relative h-[520px] flex items-center text-white"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(5,20,40,.75), rgba(5,20,40,.75)), url(/images/softwareengineering/hero.png)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="relative w-full px-6 md:px-16 lg:px-24 py-24 text-white text-left">
                    <h1 className="text-4xl md:text-5xl font-bold mb-4">
                        Software Product Engineering
                    </h1>
                    <p className="max-w-2xl text-lg text-gray-200 mb-6">
                        Design, develop, modernize and manage your software portfolio
                        for competitive advantage.
                    </p>
                    <button className="bg-orange-500 hover:bg-orange-600 px-6 py-3 rounded-md font-semibold">
                        Consult Our Experts
                    </button>
                </div>
            </section>

            {/* ================= REVIEWS ================= */}
            <section className="py-14 border-b">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-10">
                    <div>
                        <h3 className="text-xl font-semibold mb-2">
                            TechSPR Custom Software Development Services, Worldwide Reviews
                        </h3>
                        <p className="text-gray-600 mb-3">
                            Client-centricity is at the heart of everything we do.
                        </p>
                        <div className="flex items-center gap-2 text-orange-500 font-semibold">
                            ★★★★☆ <span className="text-gray-500 text-sm">4.6 / 5</span>
                        </div>
                    </div>
                    <div className="flex items-center justify-center">
                        <img
                            src="/images/softwareengineering/gartner.svg"
                            alt="Gartner"
                            className="h-10"
                        />
                    </div>
                </div>
            </section>

            {/* ================= VIDEO ================= */}
            <section className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
                    <div>
                        <h2 className="text-3xl font-bold mb-4">
                            Welcome to What Comes Next: Engineering for the Era of Digital Acceleration
                        </h2>
                        <p className="text-gray-600">
                            TechSPR brings together strategy, engineering excellence,
                            and domain expertise to help enterprises accelerate product innovation.
                        </p>
                    </div>
                    <div className="rounded-xl overflow-hidden shadow-lg">
                        <iframe
                            className="w-full h-[280px]"
                            src="https://www.youtube.com/embed/dQw4w9WgXcQ"
                            title="Software Engineering"
                            allowFullScreen
                        />
                    </div>
                </div>
            </section>

            {/* ================= OFFERINGS ================= */}
            <section className="py-20">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-10">
                    <div>
                        <h3 className="text-2xl font-bold mb-3">Product & Platform Strategy</h3>
                        <p className="text-gray-600 mb-4">
                            Define product vision, roadmap and scalable architectures.
                        </p>
                        <button className="text-orange-500 font-semibold">
                            Learn more →
                        </button>
                    </div>
                    <div>
                        <h3 className="text-2xl font-bold mb-3">Product Engineering</h3>
                        <p className="text-gray-600 mb-4">
                            Build secure, cloud-native and resilient digital products.
                        </p>
                        <button className="text-orange-500 font-semibold">
                            Learn more →
                        </button>
                    </div>
                    <div>
                        <h3 className="text-2xl font-bold mb-3">Modernization</h3>
                        <p className="text-gray-600 mb-4">
                            Transform legacy platforms using modern architectures.
                        </p>
                        <button className="text-orange-500 font-semibold">
                            Learn more →
                        </button>
                    </div>
                </div>
            </section>

            {/* ================= CTA BAND ================= */}
            <section
                className="py-24 text-white"
                style={{
                    backgroundImage:
                        "linear-gradient(120deg, #0f172a, #1e293b)",
                }}
            >
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
                    <div>
                        <h2 className="text-3xl font-bold mb-4">
                            Creating Transformational Value for Private Equity Firms
                        </h2>
                        <button className="bg-orange-500 px-6 py-3 rounded-md font-semibold">
                            Learn More
                        </button>
                    </div>
                    <img
                        src="/images/softwareengineering/sg1.png"
                        alt="Engineering"
                        className="rounded-xl shadow-xl"
                    />
                </div>
            </section>

            {/* ================= CLIENT SUCCESS ================= */}
            <section className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">
                        Client Success in Software Product Engineering
                    </h2>

                    <div className="grid md:grid-cols-3 gap-8">
                        {[
                            {
                                image:
                                    "/images/softwareengineering/cs1.png",
                                title:
                                    "Scalable SaaS Platform Built for Rapid Market Growth",
                                description:
                                    "Designed and engineered a cloud-native SaaS product supporting 5× user growth with high availability and performance.",
                            },
                            {
                                image:
                                    "/images/softwareengineering/cs2.png",
                                title:
                                    "Legacy Software Modernized into Microservices Architecture",
                                description:
                                    "Transformed a monolithic enterprise system into modular microservices, reducing deployment time by 60%.",
                            },
                            {
                                image:
                                    "/images/softwareengineering/cs3.png",
                                title:
                                    "AI-Driven Product Engineering for Intelligent Workflows",
                                description:
                                    "Integrated AI and automation to optimize business workflows, improving operational efficiency by 40%.",
                            },
                        ].map((item, index) => (
                            <div
                                key={index}
                                className="bg-white rounded-xl shadow p-6 hover:shadow-lg transition"
                            >
                                <img
                                    src={item.image}
                                    alt={item.title}
                                    className="rounded-md mb-4 h-48 w-full object-cover"
                                />

                                <h4 className="font-semibold mb-2">
                                    {item.title}
                                </h4>

                                <p className="text-sm text-gray-600">
                                    {item.description}
                                </p>

                                <button className="text-orange-500 font-semibold mt-3">
                                    Read Story →
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            {/* ================= WHY SECTION ================= */}
            <section className="py-20">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-8">
                    <div>
                        <h4 className="font-semibold mb-2">Product Engineering DNA</h4>
                        <p className="text-gray-600 text-sm">
                            Built on deep engineering heritage.
                        </p>
                    </div>
                    <div>
                        <h4 className="font-semibold mb-2">Partners in Innovation</h4>
                        <p className="text-gray-600 text-sm">
                            Strong ecosystem partnerships.
                        </p>
                    </div>
                    <div>
                        <h4 className="font-semibold mb-2">Robust Execution Framework</h4>
                        <p className="text-gray-600 text-sm">
                            Proven delivery at scale.
                        </p>
                    </div>
                </div>
            </section>

            {/* ================= NEWS ================= */}
            <section className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">
                        News & Insights
                    </h2>

                    <div className="grid md:grid-cols-3 gap-8">
                        {[
                            {
                                image:
                                    "/images/softwareengineering/news1.png",
                                title:
                                    "How Modern Software Product Engineering Accelerates Innovation",
                            },
                            {
                                image:
                                    "/images/softwareengineering/news2.jfif",
                                title:
                                    "AI, Cloud, and DevOps: Shaping the Future of Digital Engineering",
                            },
                            {
                                image:
                                    "/images/softwareengineering/news3.jfif",
                                title:
                                    "Building Scalable Products with Agile and Microservices",
                            },
                        ].map((item, index) => (
                            <div
                                key={index}
                                className="bg-white rounded-xl shadow overflow-hidden hover:shadow-lg transition"
                            >
                                <img
                                    src={item.image}
                                    alt={item.title}
                                    className="h-48 w-full object-cover"
                                />

                                <div className="p-5">
                                    <h4 className="font-semibold mb-2">
                                        {item.title}
                                    </h4>

                                    <button className="text-orange-500 font-semibold">
                                        Read More →
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            {/* ================= CONTACT ================= */}
            <section className="py-20 border-t">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-8">
                        Contact Us
                    </h2>
                    <form className="grid md:grid-cols-2 gap-6">
                        <input className="border p-3 rounded" placeholder="First name" />
                        <input className="border p-3 rounded" placeholder="Last name" />
                        <input className="border p-3 rounded" placeholder="Work email" />
                        <input className="border p-3 rounded" placeholder="Company" />
                        <textarea
                            className="border p-3 rounded md:col-span-2"
                            placeholder="How can we help?"
                            rows="4"
                        />
                        <button className="bg-orange-500 text-white px-6 py-3 rounded-md font-semibold">
                            Submit
                        </button>
                    </form>
                </div>
            </section>

        </div>
    );
};

export default SoftwareEngineeringLayout;
